





































import Dropdown from "../../core/UI/Dropdown.vue";
import { JournalEntry } from "../../models/JournalEntry";
import { DateUtils } from "../../utils/DateUtils";
export default {
    name: "AttachmentsDropdown",
    components: { Dropdown },
    props: {
        journalEntry: JournalEntry,
        dropdownMenuClass: String,
        withMailAttachments: Boolean,
        withComments: Boolean,
        buttonClass: String,
    },
    data() {
        return {
            folderFiles: [],
            commentsFiles: [],
        };
    },
    watch: {
        journalEntry: {
            immediate: true,
            deep: true,
            handler: function () {
                this.filterFiles();
            },
        },
        withComments: {
            handler: function (newVal) {
                this.filterFiles();
            },
        },
        withMailAttachments: {
            handler: function (newVal) {
                this.filterFiles();
            },
        },
    },
    methods: {
        filterFiles() {
            this.folderFiles = this.journalEntry.files;
            this.commentsFiles = [];
            if (this.withComments) {
                this.commentsFiles = _.concat(
                    this.commentsFiles,
                    this.journalEntry.get_comments_attachments(
                        this.withMailAttachments
                    )
                );
            }
            if (this.withMailAttachments) {
                this.commentsFiles = _.concat(
                    this.commentsFiles,
                    this.journalEntry.mail_attachments
                );
            }
            this.folderFiles = _.orderBy(
                this.folderFiles,
                "created_at",
                "desc"
            );
            this.commentsFiles = _.orderBy(
                this.commentsFiles,
                "created_at",
                "desc"
            );
        },
        humanReadableDate(str: string) {
            return DateUtils.sqlToDateStr(str);
        },
    },
};
